import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../Modal';
import Form, { FormBody, FormActions, TextInput, SwitchInput, SelectInput, DateInput } from '../../Form';
import _ from 'lodash';

@inject('ratingEquationStore', 'stationStore', 'parameterStore')
@observer
class RatingEquationModify extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.shape().isRequired,
  };

  slug = '/hydrology/rt_equations/list';
  disposer = null;

  @observable editMode = false;
  @observable title = '';
  @observable item = {
    name: '',
    station_id: '',
    start_time: '',
    end_time: '',
    remarks: '',
    status: 0,
    equations: [],
    stage: '',
    discharge: '',
  };

  componentDidMount() {
    const { params: { id }, ratingEquationStore } = this.props;
    this.editMode = this.props.params.id !== 'add';
    this.title = `${this.editMode ? 'Edit' : 'Add'} Rating Curve`;

    if (!!this.editMode) {
      this.reset();
    }
  }

  @action reset = () => {
    const { params: { id }, ratingEquationStore } = this.props;
    const foundUnit = ratingEquationStore.findById(id);
    if (foundUnit) {
      this.item.id = foundUnit.id;
      Object.keys(this.item).forEach(key => {
        this.item[key] = foundUnit[key];
      })
    }
  }

  @action onChangeField = (e, field) => {
    this.item[field] = e.target.value;
  }

  handleSave = (e) => {
    e.preventDefault();

    const { ratingEquationStore } = this.props;
    const { notify, router } = this.context;

    let save = () => (this.editMode ? ratingEquationStore.updateItem(this.item) : ratingEquationStore.createItem(this.item));

    save().then(() => {
      notify.success({ message: 'Success' });
      router.push(this.slug);
    }).catch(err => {
      notify.error({ message: 'Error while saving' });
    });
  }

  render() {
    const { ratingEquationStore, stationStore, params: { id }, parameterStore } = this.props;
    return (
      <Modal title={this.title} slug={this.slug} isSaving={ratingEquationStore.isSaving} isLoading={ratingEquationStore.isLoading || stationStore.isLoading || parameterStore.isLoading} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            {!!this.editMode && <TextInput label={'Id'} value={id} readOnly />}
            <TextInput label={'Name'} value={this.item.name} onChange={e => this.onChangeField(e, 'name')} />
            <SelectInput label={'Station'} value={this.item.station_id} onChange={e => this.onChangeField(e, 'station_id')} options={stationStore.items} fields={{ label: 'name', value: 'id' }} />
            <DateInput label={'Start Time'} type="datetime-local" value={this.item.start_time} onChange={e => this.onChangeField(e, 'start_time')} />
            <DateInput label={'End Time'} type="datetime-local" value={this.item.end_time} onChange={e => this.onChangeField(e, 'end_time')} />
            <TextInput label={'Remarks'} value={this.item.remarks} onChange={e => this.onChangeField(e, 'remarks')} />
            <SwitchInput label='Status' value={!!+this.item.status} onChange={() => this.item.status = ~this.item.status + 2} />
            <SelectInput label={'Stage'} value={this.item.stage} onChange={e => this.onChangeField(e, 'stage')} options={parameterStore.items} fields={{ label: 'name', value: 'id' }} />
            <SelectInput label={'Discharge'} value={this.item.discharge} onChange={e => this.onChangeField(e, 'discharge')} options={parameterStore.items} fields={{ label: 'name', value: 'id' }} />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default RatingEquationModify;



// WEBPACK FOOTER //
// ./src/components/Hydrology/RTEquations/RatingEquationModify.js